import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectService } from '../connect.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public isNavbarCollapsed:boolean;

  public showConnect() {
    this.connectService.toggleConnect(true);
  }

  navItems = [
    {
      label: "ABOUT",
      route: "/about"
    },
    {
      label: "PRODUCTS",
      route: "/products",
      // submenu: [
      //   {
      //     label: "ALL",
      //     route: "/products"
      //   },
      //   {
      //     label: "MARBLE",
      //     route: "/products/marble"
      //   },
      //   {
      //     label: "GRANITE",
      //     route: "/products/granite"
      //   },
      //   {
      //     label: "ONYX",
      //     route: "/products/onyx"
      //   },
      // ]
    },
    {
      label: "THINSLABZ",
      route: "/",
      img: "/assets/images/logo-white.png",
      home: true
    },
    {
      label: "PORTFOLIO",
      route: "/portfolio"
    },
    {
      label: "CONNECT",
      route: "/connect"

    }
  ];

  go(route: string, event: Event): void {
    event.stopPropagation();
    this.router.navigate([route]);
  }

  activeTab(route: string): boolean {
    return this.router.url === route;
  }

  constructor(private connectService: ConnectService, private router: Router) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/header/header.component.ts